import React, { Component } from "react";
import PropTypes from "prop-types";
import "./ApplicationHeader.css";


// parse html string and render html tags
function renderHtmlContent(htmlString) {
  const tagRenderers = {
    'b': (content, key) => <b key={key}>{content}</b>, //bold
    'i': (content, key) => <i key={key}>{content}</i>, //italic
    'strong': (content, key) => <strong key={key}>{content}</strong>,
    'u': (content, key) => <u key={key}>{content}</u>, //underline
  };
  
  // Handle malformed/empty HTML gracefully
  if (!htmlString || typeof htmlString !== 'string') {
    return [];
  }
  
  const tagRegex = /<(\w+)>(.*?)<\/\1>/;
  let elements = [];
  let remainingString = htmlString;
  let key = 0;
  
  while (remainingString.length > 0) {
    const match = remainingString.match(tagRegex);
    
    if (!match) {
      // No more tags, push remaining text
      if (remainingString) {
        elements.push(remainingString);
      }
      break;
    }
    
    const [fullMatch, tagName, content] = match;
    const index = match.index;
    
    // Push text before the tag
    if (index > 0) {
      elements.push(remainingString.slice(0, index));
    }
    
    // Recursively process content for nested tags
    const processedContent = renderHtmlContent(content);
    
    // Push the tag with processed content
    if (tagRenderers[tagName]) {
      elements.push(tagRenderers[tagName](processedContent, key++));
    } else {
      // Unknown tag, just push the content
      elements.push(processedContent);
    }
    
    // Continue with remaining string
    remainingString = remainingString.slice(index + fullMatch.length);
  }

  return elements;
}

class ApplicationHeader extends Component {
  static defaultProps = {
    showHorizontalRule: true,
  };

  render() {
  const { heading, message} = this.props;
    return (
      <header>
        {heading && <h1 className="application-header__heading">{heading}</h1>}
        {message && <p className="application-header__message">{typeof message === 'string' ? renderHtmlContent(message) : message}</p>}
      </header>
    );
  }
}

// Define prop types
ApplicationHeader.propTypes = {
  heading: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};


export default ApplicationHeader;
